// Reusable schema fragment for the "Specialty Rentals" section that appears
// across multiple vendor types (Photography, DJ/Band/Musician, Caterers,
// Florists, Venue, Rentals/Décor/Lighting). Building it once here means
// changes to this section's structure only need to happen in one place,
// instead of being hand-duplicated per vendor type's schema.
//
// Some vendor types gate this whole section behind a checkbox
// (e.g. Florists' "We offer rental items"); Rentals/Décor/Lighting shows it
// unconditionally since renting is their entire business. Pass the
// checkbox field's key to gate it, or omit/pass null to leave it ungated.

import {
  SPECIALTY_RENTALS,
  MOBILE_EVENT_TYPES,
  PHOTO_BOOTH_SERVICE_OPTIONS,
  PHOTO_BOOTH_MODES,
  EVENT_ITEMS,
} from '../../constants/vendorOptions';

export function rentalItemsGroupFields(gatedByKey, nestedStyle) {
  const resolvedNestedStyle = nestedStyle || (gatedByKey ? 'nested' : 'shaded');
  const groupFields = [
    { key: 'specialtyRentals', type: 'chips', label: 'Specialty Rentals', options: SPECIALTY_RENTALS, optional: true },
    {
      key: 'mobileEventsGroup',
      type: 'group',
      style: resolvedNestedStyle,
      showIf: { field: 'specialtyRentals', includes: 'Mobile Events' },
      fields: [
        { key: 'mobileEventTypes', type: 'chips', label: 'Type of Mobile Event', displayLabel: 'Mobile Event Types', options: MOBILE_EVENT_TYPES, optional: true, substituteOptionWith: { option: 'Other', valueKey: 'mobileEventOther' } },
        { key: 'mobileEventOther', type: 'text', label: 'Describe Other Mobile Event', displayLabel: 'Other Mobile Event', maxLength: 50, showIf: { field: 'mobileEventTypes', includes: 'Other' }, hideFromDisplay: true },
      ],
    },
    {
      key: 'photoBoothGroup',
      type: 'group',
      style: resolvedNestedStyle,
      showIf: { field: 'specialtyRentals', includes: 'Photo Booth' },
      fields: [
        { key: 'photoBoothServiceOptions', type: 'chips', label: 'Photo Booth Options', options: PHOTO_BOOTH_SERVICE_OPTIONS, optional: true },
        { key: 'photoBoothModes', type: 'chips', label: 'Modes Available', displayLabel: 'Photo Booth Modes', options: PHOTO_BOOTH_MODES, optional: true },
      ],
    },
    { key: 'eventItems', type: 'chips', label: 'Event Items', options: EVENT_ITEMS, optional: true },
  ];

  if (!gatedByKey) return groupFields;

  return [{
    key: `${gatedByKey}_group`,
    type: 'group',
    style: 'shaded',
    showIf: { field: gatedByKey, equals: true },
    fields: groupFields,
  }];
}